import React, { useEffect, useState } from 'react'

import Breadcrumb from '../../../common/Breadcrumb'
import { useDispatch, useSelector } from 'react-redux'
import { ErrorMessage, Form, Formik } from 'formik'
import {
  addConfigureBreedList,
  herdConfigureBreedList,
  getConfigureBreedList,
} from '../../../store/actions'
import * as Yup from 'yup'
import _ from 'lodash'
import BreedList from './BreedList/BreedList'
import { Card, CardHeader } from '../Atoms'
import { Button, CardBody, Col, Row, Spinner } from 'reactstrap'
import { toast } from 'react-toastify'

const HerdConfigure = (props) => {
  const dispatch = useDispatch()
  const [waitingForRefresh, setWaitingForRefresh] = useState(false)
  const { herdConfigurationForm, herdConfigurationFormLoading } = useSelector(
    (state) => {
      return {
        herdConfigurationForm:
          state?.herdManagement?.herdConfiguration?.form || {},
        herdConfigurationFormLoading:
          state?.herdManagement?.herdConfiguration?.formLoading,
      }
    }
  )

  const validationSchema = Yup.object({
    breed_list: Yup.array().test(
      'at-least-one-new-checked',
      `Please select at least one new breed to add`,
      (value) => {
        if (!Array.isArray(value)) return false
        // Check if there's at least one newly checked breed (not previously saved)
        const allBreeds = _(value)
          .map('breed')
          .flatten()
          .value()
        return allBreeds.some(
          (breed) => breed.isSelected && !breed.isPreviouslySaved
        )
      }
    ),
  })

  useEffect(() => {
    dispatch(herdConfigureBreedList())
  }, [])

  useEffect(() => {
    if (!herdConfigurationFormLoading && waitingForRefresh) {
      setWaitingForRefresh(false)
    }
  }, [herdConfigurationFormLoading, waitingForRefresh])

  const addApi = (body) => {
    return new Promise((resolve, reject) => {
      dispatch(
        addConfigureBreedList(body, (err, data) => {
          if (err) {
            reject(err)
          } else {
            resolve(data)
          }
        })
      )
    })
  }
  const onSubmit = async (values, formProps) => {
    formProps.setStatus(true)
    try {
      // Only send newly checked breeds (not previously saved ones)
      const obj = _(values.breed_list)
        .map((breed) => {
          return {
            // club_type: ClubTypeForm.club_type,
            breed_category: breed.breed_category_abbre,
            breed_list: _.map(
              _.filter(
                breed.breed,
                (q) => q.isSelected && !q.isPreviouslySaved
              ),
              (b) => ({
                breed_id: b.breed_id,
              })
            ),
          }
        })
        .filter((q) => _.size(q.breed_list))
        .value()
      
      // Only submit if there are new breeds to add
      if (obj.length === 0) {
        formProps.setStatus(false)
        toast.warning('No new breeds selected to add')
        return
      }

      const res = await addApi(obj)

      if (res) {
        toast.success(res)
        // The saga already calls getConfigureBreedList() after successful submission
        // Set flag to wait for data refresh
        setWaitingForRefresh(true)
        // Reset form status after a short delay to allow form to update
        setTimeout(() => {
          formProps.setStatus(false)
        }, 2000)
      }
    } catch (err) {
      formProps.setStatus(false)
      if (Array.isArray(err)) {
        toast.error(_.get(_.first(err), 'msg'))
      } else if (err) {
        toast.error(err)
      }
    }
  }
  return (
    <Card className='layout'>
      <Row>
        <CardHeader>
          <Row>
            <Breadcrumb title='Configuration' />
          </Row>
        </CardHeader>
        <CardBody>
          {!herdConfigurationFormLoading ? (
            <Col lg='12'>
              <Formik
                initialValues={herdConfigurationForm}
                onSubmit={onSubmit}
                enableReinitialize
                // validateOnChange={false}
                // validateOnBlur={false}
                validationSchema={validationSchema}
              >
                {({ values, status }) => {
                  return (
                    <Form className='needs-validation club-selection'>
                      <Row className='mt-3'>
                        <Col md='12'>
                          {' '}
                          <BreedList />
                        </Col>
                        <Col md='12' className='text-center'>
                          <ErrorMessage
                            name='breed_list'
                            className='text-danger text-bold'
                            component='div'
                          />
                        </Col>
                      </Row>
                      <Col md={12} className='text-center'>
                        <Button
                          type='submit'
                          disabled={status}
                          color='success'
                        >
                          SUBMIT
                        </Button>
                      </Col>
                    </Form>
                  )
                }}
              </Formik>
            </Col>
          ) : (
            <Col lg='12' className='text-center'>
              <Spinner color='primary' />
            </Col>
          )}
        </CardBody>
      </Row>
    </Card>
  )
}

HerdConfigure.propTypes = {}

export default HerdConfigure